class AddToCartError extends Error {
  constructor({ product, serverError }) {
    const { code, error_code, message, meta } =
      serverError?.errors || {};

    super(
      message || `Something went wrong when adding ${product.name}`,
    );

    this.name = 'AddToCartError';
    this.code = code || error_code;
    this.meta = meta;
    this.product = product;
  }
}

export default AddToCartError;
